import React, { FC } from "react";
import {
  ContentWrapper,
  Heading,
} from "containers/RightPanel/RightPanel.styles";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Content } from "../../../../components/Addresses/components/AddressForm.styles";
import Input from "../../../../components/Input/Input";

interface ShopifyItemViewPanelProps {
  panelData: any;
  isOpen: boolean;
}

const ShopifyItemViewPanel: FC<ShopifyItemViewPanelProps> = ({ panelData }) => {
  const { t } = useTranslation("common");
  const item = panelData.get("item");
  const profileName = panelData.get("profileName");

  return (
    <ContentWrapper>
      <Heading>{t("shopify.items")}</Heading>
      <ViewContent>
        <Input
          label={t("shopify.storeName")}
          value={profileName}
          disabled
        />
        <Input
          label={t("shopify.itemId")}
          value={item.get("item_id")}
          disabled
        />
        <Input
          label={t("shopify.state")}
          value={item.get("state")}
          disabled
        />
      </ViewContent>
    </ContentWrapper>
  );
};

export default ShopifyItemViewPanel;

const ViewContent = styled(Content)`
  label {
    margin-bottom: 10px;
  }
`;
